<template>
  <div>
    <WebQuestionEditor
      v-if="codingObjectReady"
      mode="edit"
      :codingObject="codingObject"
      @CODING_OBJECT_EMITTED="handleCodingObject"
    />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import WebQuestionEditor from "@/components/Web/WebQuestionEditor"

export default {
  components: {
    WebQuestionEditor,
  },
  data() {
    return {
      codingObject: {},
      codingObjectReady: false,
    }
  },
  created() {
    this.getQuestion()
  },
  methods: {
    handleCodingObject(obj) {
      this.axios({
        method: "put",
        url: `${siteConfig.siteURL}questions/${this.$route.params.id}`,
        data: obj,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.$router.push("/web-questions/")
      })
    },
    getQuestion() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}questions/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.codingObject = res.data.data
        this.codingObjectReady = true
      })
    },
  },
}
</script>
